export const ADMIN_ROLES = {
  requestsManager: 'requests_manager',
  questionsManager: 'questions_manager',
  advisorsManager: 'advisors_manager',
  clientsManager: 'clients_manager',
  consultantsManager: 'consultants_manager',
};

export const SUPER_ADMIN = 'super_admin';

export const USER_TYPES = {
  client: 'client',
  corporate: 'corporate',
  freelancer: 'freelancer',
  admin: 'admin',
  adviser: 'adviser',
};
